import React from 'react';
import { ModalTheme } from '@/components/modal/index.jsx';
import { FORM_SYNC_OLD_TEL, useFormState } from '../forms/index.js';
import { useForm } from 'react-hook-form';
import { ButtonTheme, RenderForm } from '@/components/index.js';
import { ContainerButton } from '@/styles/global-style.js';
import { useEffect } from 'preact/hooks';
import { useUpdateTel } from '../hooks/useUpdateTel.js';

export const TelEdit = ({ open, onToggle, initialValues, onFetch, onCloseAll }) => {
  const { defaultValues } = useFormState(initialValues);
  const { control, setValue, getValues, handleSubmit } = useForm({
    defaultValues,
  });
  const { mutate: onSubmitUpdateTel } = useUpdateTel({
    onSuccessCallBack: () => {
      onFetch();
      onCloseAll();
    },
  });

  useEffect(() => {
    if (!initialValues) {
      return;
    }
    Object.keys(initialValues).forEach((key) => {
      setValue(key, initialValues[key]);
    });
  }, [initialValues, setValue]);

  const onSubmit = (value) => {
    onSubmitUpdateTel(value);
    onToggle({ defaultValues: '' });
  };

  return (
    <ModalTheme
      title="แก้ไขเบอร์ติดต่อใหม่"
      open={open}
      onToggle={onToggle}
      initialValues={initialValues}
      onFetch={onFetch}
    >
      <RenderForm
        control={control}
        forms={FORM_SYNC_OLD_TEL()}
        setValue={setValue}
        getValues={getValues}
      />
      <ContainerButton>
        <ContainerButton right>
          <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
          <ButtonTheme useFor="CANCEL" onClick={onToggle} />
        </ContainerButton>
      </ContainerButton>
    </ModalTheme>
  );
};
